import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  pt_news: string = 'pt-100';
  pt: string = 'pt-0';
  pb: string = 'pb-70'; 
  ptb: string = 'ptb-100'; 
  section: string = 'faq'; 
  contact_tile: string = 'Cualquier pregunta que tengas no dudes en contactarnos.'; 

  constructor() { }

  ngOnInit(): void {
  }

}
